import styled from "@emotion/styled";

export const MainContainer = styled.div`
  display: grid;
  grid-template-rows: 15% 90%;
  height: 100%;

  & > * {
    padding: 3rem 2rem;
  }
  `;
  export const HeaderContainer = styled.div`
  display:grid;
  grid-template-columns: 50% 50%;
  `;
  export const btnContainer = styled.div`

display:grid;
justify-self: flex-end;

`;
export const CreateBtn = styled.button`
display:grid;
justify-self: flex-end;

  padding: 0.8rem 38px;
  border: 0.5px solid #000;
  border-radius: 40px;
  background-color: transparent;
  color: #080808;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
  
`;
  export const FolderContainer = styled.div`
  width: 60%;
  display: grid;
  justify-content: flex-start;
  grid-auto-rows: min-content;
  align-items: self-start;
  grid-template-columns: repeat(8, 1fr);
  gap: 1rem;
`;

export const H1 = styled.h1`
 
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;